import Hotkeys from 'react-hot-keys';
import { motion } from 'framer-motion';
import { PureComponent, ReactNode } from 'react';
import { LabTestsEntityOrProceduresEntity } from '../../../../store/types/prescription';
import { Checkbox } from 'antd';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import { CloseBtIcon } from './BookLabTestsUtils';

interface LabTests extends LabTestsEntityOrProceduresEntity {
    isSelected: boolean;
}

type Props = {
    closeMe: () => void;
    onSave: (selectedLabTests: LabTestsEntityOrProceduresEntity[]) => void;
    prescriptionLabTests: LabTestsEntityOrProceduresEntity[];
    selectedLabTests: Set<string>;
};

type State = {
    selectedLabTests: LabTests[];
};

class EditLabTestModal extends PureComponent<Props, State> {
    state: State = {
        selectedLabTests: this.props.prescriptionLabTests.map((i) => ({
            ...i,
            isSelected: this.props.selectedLabTests.has(i.id),
        })),
    };

    onChange = (e: CheckboxChangeEvent, curIndex: number): void => {
        const { selectedLabTests } = this.state;
        this.setState({
            selectedLabTests: selectedLabTests.map((i, index) => {
                if (curIndex === index) return { ...i, isSelected: e.target.checked };
                return i;
            }),
        });
    };

    saveLabTestsHandler = (): void => {
        const { onSave } = this.props;
        const { selectedLabTests } = this.state;
        onSave(selectedLabTests.filter((i) => i.isSelected));
    };

    render(): ReactNode {
        const { closeMe } = this.props;
        const { selectedLabTests } = this.state;
        const { onChange, saveLabTestsHandler } = this;

        return (
            <Hotkeys keyName="esc">
                <motion.div
                    initial={{ opacity: 0 }}
                    exit={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    style={{ zIndex: 20 }}
                    transition={{ duration: 0.2, ease: 'linear' }}
                    className="font-lato select-none"
                >
                    <div className="modal-overlay" onClick={closeMe}></div>
                    <div className="modal-content w-440 max-h-360 h-4/5 font-lato font-400 rounded-8">
                        <div className="h-full flex flex-col">
                            <div className="flex items-center justify-between px-16 py-14 bg-neutral-9 rounded-t-8">
                                <p className="font-700 text-16">Prescribed Lab Tests</p>
                                <CloseBtIcon closeMe={closeMe} />
                            </div>

                            <div className="flex-1 p-16 space-y-12 font-700 text-darwin-neutral-800 overflow-scroll hide-scrollbar">
                                {selectedLabTests.map((i, index) => (
                                    <div className="flex space-x-16 items-start justify-between">
                                        <div className="flex space-x-5">
                                            <p>{index + 1}.</p>
                                            <p>{i.name}</p>
                                        </div>
                                        <div>
                                            <Checkbox
                                                onChange={(e: CheckboxChangeEvent) =>
                                                    onChange(e, index)
                                                }
                                                checked={i.isSelected}
                                            />
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="flex items-center justify-between px-16 py-9 bg-neutral-9 rounded-b-8">
                                <p
                                    className="text-neutral-3 font-700 cursor-pointer"
                                    onClick={closeMe}
                                >
                                    Cancel
                                </p>
                                <button
                                    className="btn--small primary-btn px-16 py-8"
                                    onClick={saveLabTestsHandler}
                                    disabled={!selectedLabTests.some((i) => i.isSelected)}
                                >
                                    Save
                                </button>
                            </div>
                        </div>
                    </div>
                </motion.div>
            </Hotkeys>
        );
    }
}

export default EditLabTestModal;
